import { render, staticRenderFns } from "./rootContainerCutline.vue?vue&type=template&id=049a2fbc&scoped=true&lang=pug&"
import script from "./rootContainerCutline.vue?vue&type=script&lang=js&"
export * from "./rootContainerCutline.vue?vue&type=script&lang=js&"
import style0 from "./rootContainerCutline.vue?vue&type=style&index=0&id=049a2fbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a2fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('049a2fbc', component.options)
    } else {
      api.reload('049a2fbc', component.options)
    }
    module.hot.accept("./rootContainerCutline.vue?vue&type=template&id=049a2fbc&scoped=true&lang=pug&", function () {
      api.rerender('049a2fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/preview_area/rootContainerCutline.vue"
export default component.exports